import PropTypes from 'prop-types';
import EventTimingStatusImpl from './event-timing-status.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * View displaying event details like stream availability
 * and start date/time.
 *
 * @class EventTimingStatus
 * @memberof Mojito.Presentation.Components
 */

/**
 * EventTimingStatus prop types.
 *
 * @property {object} eventItem - The event object.
 * @property {Function} [onClick = ()=>{}] - Callback function that is triggered once component is clicked.
 * @property {number} [inplayTime] - The amount of seconds which indicates how much time has passed since event became live.
 * @property {boolean} [hasClockDetails = false] - Event has clock details data. Which means that clocks are ticking for inplay event.
 * @property {boolean} [hasStreaming = false] - Event has streaming data.
 *
 * @memberof Mojito.Presentation.Components.EventTimingStatus
 */
const propTypes = {
    eventItem: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    inplayTime: PropTypes.number,
    hasClockDetails: PropTypes.bool,
    hasStreaming: PropTypes.bool,
};

const defaultProps = {
    onClick: noop,
    hasClockDetails: false,
    hasStreaming: false,
};

export default UIView('EventTimingStatus', EventTimingStatusImpl, propTypes, defaultProps);
